import {
  Heading3,
  TextBody,
} from '@front/components/data-display/typography/Typography'
import { useScreenSize } from '@front/components/hooks/useScreenSize'
import { AppButton } from '@front/components/inputs/app-button'
import { IconButton } from '@front/components/inputs/icon-button'
import { CloseOutlined } from '@mui/icons-material'
import { Box, Dialog, Drawer, Stack, useTheme } from '@mui/material'
import { Fragment } from 'react'

type DialogProps = {
  pageList: string[]
  handleChangePage: (index: number) => void
  isOpen: boolean
  handleClose: () => void
}

export default function PageTabSelectDialog({
  pageList,
  handleChangePage,
  isOpen,
  handleClose,
}: DialogProps) {
  const theme = useTheme()

  const { isSmallScreen } = useScreenSize()

  const goToPage = (page: number) => {
    handleChangePage(page)
    handleClose()
  }

  const Content = () => {
    return (
      <Stack
        sx={{
          gap: 1,
          px: 2,
          py: 1.75,
          overflow: 'hidden',
          borderRadius: '8px',
          backgroundColor: theme.palette.background.surface,
        }}
      >
        <Stack
          sx={{
            position: 'relative',
            width: { xs: '100%', md: '400px' },
          }}
        >
          <Heading3
            sx={{ textAlign: { xs: 'start', md: 'center' }, margin: 1 }}
          >
            Menu {/** Translation not needed */}
          </Heading3>
          <IconButton
            sx={{
              width: 24,
              height: 24,
              position: 'absolute',
              top: '10px',
              right: { xs: '8px', md: '16px' },
            }}
            onClick={handleClose}
          >
            <CloseOutlined sx={{ color: theme.palette.text.brand }} />
          </IconButton>
        </Stack>
        {pageList.map((i, j) => {
          return (
            <Fragment key={i}>
              <AppButton
                variant="text"
                sx={{ justifyContent: 'start' }}
                onClick={() => {
                  goToPage(j)
                }}
              >
                <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                  <TextBody sx={{ color: theme.palette.text.primary }}>
                    {i}
                  </TextBody>
                </Stack>
              </AppButton>
              <Stack
                sx={{
                  flexDirection: 'row',
                  display: j === pageList?.length - 1 ? 'none' : 'flex',
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: '1px',
                    backgroundColor:
                      theme.palette.action['primary-bg-disabled'],
                  }}
                />
              </Stack>
            </Fragment>
          )
        })}
      </Stack>
    )
  }

  if (isSmallScreen) {
    return (
      <Drawer
        anchor="bottom"
        open={isOpen}
        onClose={handleClose}
        slotProps={{
          paper: { sx: { borderRadius: '16px 16px 0 0' } },
        }}
      >
        <Content />
      </Drawer>
    )
  }

  return (
    <Dialog
      disableEnforceFocus
      open={isOpen}
      onClose={handleClose}
      PaperComponent={Content}
    />
  )
}
